export default "__VITE_ASSET__B_Pg7w3$__"